var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert || _vm.audioOnly)?_c('span',{attrs:{"id":"network-alert"}},[_vm._v(_vm._s(_vm.networkMessage))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }